import React from 'react'
import { useDisplayTheme } from 'hooks/useUiState'
// @ts-ignore
import { QLogo } from '@netbasequid/core'
// @ts-ignore
import { ref } from '@netbasequid/theme'
import { useTranslation } from 'react-i18next'
import { StyledLoadingButton, StyledLogo } from './index.css'

const SavingButton = () => {
  const theme = useDisplayTheme()
  const { t } = useTranslation()

  return (
    <StyledLoadingButton>
      <StyledLogo>
        <QLogo
          fontSize={16}
          mode={theme}
          color={theme === 'light' ? ref.color.gray[100] : ref.color.gray[1400]}
        />
      </StyledLogo>
      {t('savingThreeDot')}
    </StyledLoadingButton>
  )
}

export default SavingButton
